import React from 'react';
import { prop } from 'ramda';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getURLParam } from '@core/js/utils/url.util';
import { useDeviceSelector, useUserSelector } from '@core/js/store/hooks';

import * as hocs from '@core/js/components/system/Page/hocs';
import * as hooks from '@core/js/components/system/Page/hooks';
import * as helpers from '@core/js/components/system/Page/helpers';
import { Layout } from '@theme/js/components/system/Page/components/Layout';
import { PageLoader } from '@core/js/components/system/Page/components/PageLoader';

export const PageBare = ({ page, isLoading, fetchPageInfo, defaultPage }) => {
    const location = useLocation();
    const role = useUserSelector(prop('role'));
    const isPageAsPopUpDisabled = getURLParam(location.search, 'noPageAsPopup') === '1' || role === 'admin';

    const htmlBaseClasses = useDeviceSelector(prop('htmlBaseClasses'));

    hooks.useLegacyPageRenderedTrigger({ page });
    hooks.useCMSIntegration({ page, fetchPageInfo });

    if (!page) {
        return <PageLoader /> ;
    }

    const pageStyles = helpers.getPageStyles({ page });

    return <>
        <Helmet htmlAttributes={{ class: helpers.getPageClassNames(page.rootClassNames, htmlBaseClasses) }} >
            <style type="text/css">{pageStyles}</style>
        </Helmet>
        {(!page.showAsPopUp || isPageAsPopUpDisabled) && <Layout page={page} isLoading={isLoading} defaultPage={defaultPage} />}
    </>;
};

export const Page = hocs.withCommonPage(PageBare);
